/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_Tools_DescriptionInputs */



/**
* | output |
* | --- |
* | "These function calls become available to the AI when this integration is enabled." |
*
* @param {Integrations_Dialog_Tools_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_tools_description = /** @type {((inputs?: Integrations_Dialog_Tools_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_Tools_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Funktionsaufrufe stehen der KI zur Verfügung, sobald diese Integration aktiviert ist.")
	return /** @type {LocalizedString} */ ("These function calls become available to the AI when this integration is enabled.")
});